export const setTokens = (accessToken: string, idToken: string, refreshToken: string) => ({
	type: "SET_TOKENS",
	payload: { accessToken, idToken, refreshToken },
});

export const clearTokens = () => ({
	type: "CLEAR_TOKENS",
});
